<template>
  <v-container
    pa-0
    :style="$route.path == '/user/edit' ? 'width:60%' : 'width:100%'"
  >
    <v-card style="border-radius: 15px">
      <v-card-title class="subheading" style="padding: 8px; margin: 0px">
        {{ user.first_name }}
        <v-spacer />
        <v-btn
          @click="submit"
          small
          color="indigo white--text darken-4"
          style="border-radius: 5px"
          >Save</v-btn
        >
        <v-btn icon
          ><v-icon @click="closeDialog" medium
            >fas fa-times-circle</v-icon
          ></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs2>
            <span>
              <ImageCard
                :documentId="user.logo_profile_id"
                :keyId="user.id"
                height="48px"
                size="large"
                width="48px"
                v-on:imageChanged="updateLogo"
              />
            </span>
          </v-flex>
          <v-flex xs10>
            <v-layout row wrap>
              <v-flex xs12 pr-2>
                <strong>Email</strong> <br /><br />
                <v-text-field
                  class="style-input mr-2"
                  v-validate="'required'"
                  data-vv-name="email"
                  type="email"
                  outline
                  single-line
                  :rules="[rules.required, rules.email]"
                 :error-messages="errors.collect('email') "
                  v-model="user.email"
                  required
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6 pr-2>
                <strong>First Name</strong> <br /><br />

                <v-text-field
                  class="style-input mr-2"
                  outline
                  single-line
                  :error-messages="errors.collect('firstName')"
                  v-model="user.first_name"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pr-2>
                <strong>Last Name</strong> <br /><br />

                <v-text-field
                  class="style-input mr-2"
                  v-model="user.last_name"
                  outline
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pr-2>
                <strong>User Type</strong> <br /><br />

                <v-select
                  class="style-input mr-2"
                  v-model="user.user_type"
                  item-text="name"
                  item-value="id"
                  :readonly="role.user_type != 'A'"
                  outline
                  single-line
                  :items="userTypes"
                />
              </v-flex>

              <v-flex xs6 pl-2>
                <strong>Mobile</strong> <br /><br />
                <v-text-field
                  class="style-input mr-2"
                  outline
                  @input="checkMobileNumber"
                  @change="checkMobileNumber"
                  single-line
                  v-model="user.mobile"
                  :error-messages="
                    mobileErr ? mobileErr : errors.collect('mobile')
                  "
                  type="mobile"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="user.user_type != 'A'">
                <strong>Company</strong> <br /><br />

                <v-select
                  class="style-input mr-2"
                  v-model="user.company_list"
                  item-text="name"
                  :readonly="role.user_type != 'A'"
                  item-value="team"
                  small-chips
                  outline
                  multiple
                  single-line
                  :items="company"
                />
              </v-flex>

              <v-flex xs3 v-if="role.user_type == 'A'">
                <v-switch
                  v-model="user.super_user"
                  label="Super User"
                  color="red"
                  hide-details
                ></v-switch>
              </v-flex>
              <v-flex xs3 v-if="role.user_type == 'A'">
                <v-switch
                  v-model="user.active"
                  label="Active"
                  color="red"
                  hide-details
                ></v-switch>
              </v-flex>
              <v-flex xs3 v-if="role.user_type == 'A'">
                <v-switch
                  v-model="user.lock_user"
                  label="Lock User"
                  color="red"
                  hide-details
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions justify-center> </v-card-actions>
    </v-card>
  </v-container>
</template>
<style>
</style>
<script>
//import UserModel from '../../api/service/UserService.js';

import UserModel from "@/api/service/UserService";
import CompanyModel from "@/api/service/CompanyService";
import ImageCard from "@/components/ImageCard.vue";
import RoleModel from "@/api/service/RolesService";
export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ImageCard,
  },
  props: ["userData"],
  data: () => ({
    rules: {
      required: value => !!value || "Required.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid Email.";
      }
    },
    
    saveCard: true,
    mobileErr: false,
    userTypes: [
      { id: "P", name: "Production" },
      { id: "S", name: "Support" },
      { id: "A", name: "Administrator" },
      { id: "M", name:"Manager"},
    ],
    valid: true,
    authTypes: [
      { id: "TB", name: "Tibura" },
      { id: "LD", name: "Ldap" },
      { id: "GO", name: "Gmail" },
      { id: "36", name: "Office 365" },
    ],
    user: {
      email: "",
      password: "",
      emailerror: false,
      passworderror: false,
    },
    company: {},
    role: {},
  }),
  created: function () {
    this.getRole();
    if (this.$route.query.id || this.userData.id) {
      var $id = this.$route.query.id ? this.$route.query.id : this.userData.id;
      this.getUser($id);
    } else {
      this.user = {
        email: "",
        password: "",
        emailerror: false,
        passworderror: false,
      };
    }
    this.getCompany();
  },
  mounted: function () {},

  methods: {
    async getRole() {
      var $data = await RoleModel.getRoleForMyId();
      this.role = $data[0];
    },
    //  getFieldText(item) {
    //      return `{id:${item.id} ,team: ${item.team}}`
    //     // var $data = {};
    //     // ($data.id = item.id), ($data.name = item.name);
    //     // return $data;
    //   },
    async checkMobileNumber($no) {
      await UserModel.findAll({ mobile: $no })
        .then((response) => {
          console.log("user data ", response);
          if (this.user.id) {
            this.mobileErr =
              response.length == 1
                ? response[0].id == this.user.id &&
                  response[0].mobile == this.mobile.mobile
                  ? ""
                  : "Already Exist"
                : response.length == 0
                ? ""
                : "Already Exist";
            //alert(JSON.stringify(response,null,4))
          } else {
            this.mobileErr = response.length > 0 ? "Already Exist" : "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
      // if ($data.length > 0) {
      //   this.mobileErr = "Already Exists";
      // } else {
      //   this.mobileErr = false;
      // }
    },
    checkCode() {
      CategoryModel.checkUniqueCode({ short_name: this.category.short_name });
    },
    async getUser($id) {
      var $user = await UserModel.findAll({ id: $id });
      this.user = $user[0];
      this.user.company_list = this.user.company_list
        ? JSON.parse(this.user.company_list)
        : [];
    },
    async getCompany() {
      this.company = await CompanyModel.findAll({});
    },
    setUsers($user) {
      this.user = $user[0]; //$user[0];
      //this.user.user_preferences =JSON.parse(this.user.user_preferences)
      console.log(this.user);
    },
    validate() {
      if (this.user.email === "") {
        this.valid = false;
        this.emailerror = false;
      }
    },
    async updateLogo($image) {
      this.user.logo_profile_id = $image.id;
      this.$forceUpdate();
      // await UserModel.save({ id: this.user.id, logo_profile_id: $image.id });
    },
    submit() {
      this.$validator.validateAll();
      this.validate();
      console.log(this.valid);
      if (this.valid) {
        var navigate = this.$router;
        var stores = this.$store;

        if (this.user.id) {
          UserModel.save(this.user)

            .then((response) => {
              this.$emit("closeDialog", response);
            })
            .catch((error) => {
              console.log(error);
              console.log("I am getting error");
            });
        } else {
          UserModel.create(this.user)
            .then((response) => {
              this.$emit("closeDialog", response);
            })
            .catch((error) => {
              console.log(error);
              console.log("I am getting error");
            });
        }
      }
    },
    closeDialog() {
      //this.user = {};
      //this.$validator.reset();
      this.$emit("closeDialog", null);
    },
    validatePortal() {
      UserModel.validate(this.user);
    },
  },
};
</script>

<style  >
.style-input {
  padding: 0px;
  margin: 0px;
  width: 100%;
}
</style>
